<template>
  <div id="plannerClass" class="admin-wrap" style="margin-top: 10px">
    <div class="header mb-5">
      <K2Row space-between="true">
        <h4 class="text-left mb-3">{{ lang("Assign Individual Child's Learning Goals") }}</h4>
        <div class="Class search">
          <div class="col-lg-24 text-right actionDiv">
            <el-select
              v-model="ddlClass"
              :placeholder="lang('Select Class')"
              class="pro-edt-select"
              @change="val => ClassChange(val)"
              style="margin-right: 10px"
              id="ddlClassID"
            >
              <el-option
                v-for="item in ddlClassList"
                :key="item.PK_Class_ID"
                :label="item.CLS_ClassName + ' (' + item.SMT_Year + ') ' + item.CLS_Batch"
                :value="item.PK_Class_ID"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="ddlStudent"
              :placeholder="lang('Select Student')"
              class="pro-edt-select"
              @change="SelectStudent()"
              style="margin-right: 10px"
              id="ddlClassID"
            >
              <el-option v-for="item in ddlStudentList" :key="item.Student_ID" :label="item.Student_Name" :value="item.Student_ID"> </el-option>
            </el-select>
            <b-button variant="" style="margin-right: 10px" @click="resetStudent()" v-if="ddlStudent !== ''"> Reset Student </b-button>
            <b-button variant="success" style="margin-right: 10px" v-if="ddlStudent !== ''" @click="saveStudentGoals2()">
              {{ lang('Save') }}
            </b-button>
            <b-button variant="success" style="margin-right: 10px" v-else @click="saveClassGoals2()">
              {{ lang('Save') }}
            </b-button>
          </div>
        </div>
      </K2Row>
    </div>
    <div>
      <div class="empty-list_image" v-if="ddlClass === ''">
        <strong>{{ lang('Select a class to start') }}...</strong>
        <img src="../../assets/notfound.png" />
      </div>
      <div class="formDiv" v-else>
        <div class="Domains" role="tablist" v-for="(domain, i) in ddlGoalsList">
          <b-card no-body class="mb-2 border-0 border-bottom">
            <b-card-header header-tag="header" class="p-1 box purple border-0" role="tab">
              <K2Row space-between="true" class="p-2">
                <K2Row align="center" v-b-toggle="'my-collapse' + i">
                  <K2Icon color="black" name="add" class="when-closed me-2" :font-size="uiVariable.fontSize.md" style="line-height: 16px" />
                  <K2Icon color="black" name="remove" class="when-open me-2" :font-size="uiVariable.fontSize.md" style="line-height: 16px" />
                  <a> {{ domain.PlnMasDomain }}</a>
                </K2Row>

                <K2Row space-between="true" class="when-open" style="width: 280px" v-if="isPNN1">
                  <span style="width: 70px">PNS1</span>
                  <span style="width: 70px">PNS2</span>
                  <span style="width: 70px">N1S1</span>
                  <span style="width: 70px">N1S2</span>
                </K2Row>

                <K2Row space-between="true" class="when-open" style="width: 280px" v-else>
                  <span style="width: 70px">Term 1</span>
                  <span style="width: 70px">Term 2</span>
                  <span style="width: 70px">Term 3</span>
                  <span style="width: 70px">Term 4</span>
                </K2Row>
              </K2Row>
            </b-card-header>
            <b-collapse v-bind:id="'my-collapse' + i" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <!--<div v-for="(item) of ddlGoalsList" class="mb-3  pb-2" :key="item.PlnMasDomain">-->
                <div v-for="(item, index) of handleSelectGoals(domain.PlnMasDomain)" :key="item.CombineGoals">
                  <div class="plannerGoals mb-4" v-if="item.CombineGoals">
                    <K2Text class=" ">Learning Goal {{ item.goalOrder }} : {{ item.CombineGoals }} </K2Text>
                  </div>
                  <div class="indicator">
                    <K2Text class="plannerLabel mb-2">Knowledge, Skills and Dispositions (KSDs) </K2Text>
                  </div>
                  <div class="plannerIndicator" :class="ddlStudent && 'isStudent'">
                    <K2Row v-for="(indicator, i) of item.ArrObj_Items" class="border-bottom mb-3" :key="i">
                      <div class="indicator">
                        <K2Text class="indicator">
                          {{ indicator && indicator[0].PlnMasOrder }}
                          {{ indicator && indicator[0].combineIndicator }}
                        </K2Text>
                        <!--<br/>-->
                        <!--<K2Text class="indicator hints"> Possible Evidence/Indication:-->
                        <!--{{indicator.PlnMasGoalsITL}}-->
                        <!--</K2Text>-->
                      </div>
                      <el-checkbox
                        :value="indicator.term1"
                        class="indicatorLabel"
                        :id="isPNN1 && !indicator[0].PlnMasLevels.includes('PNS1') ? 'invalid' : ''"
                        :disabled="true"
                        @change="() => onIndicatorCheck(indicator, 'term1')"
                      ></el-checkbox>
                      <el-checkbox
                        :value="indicator.studentTerm1"
                        class="studentIndicatorLabel"
                        :disabled="indicator.term1 || (isPNN1 && selectedLevel === 'N1')"
                        v-if="ddlStudent"
                        @change="() => onIndicatorCheck(indicator, 'studentTerm1')"
                      ></el-checkbox>

                      <el-checkbox
                        :value="indicator.term2"
                        class="indicatorLabel"
                        :disabled="true"
                        :id="isPNN1 && !indicator[0].PlnMasLevels.includes('PNS2') ? 'invalid' : ''"
                        @change="() => onIndicatorCheck(indicator, 'term2')"
                      ></el-checkbox>
                      <el-checkbox
                        :value="indicator.studentTerm2"
                        class="studentIndicatorLabel"
                        v-if="ddlStudent"
                        :disabled="indicator.term2 || (isPNN1 && selectedLevel === 'N1')"
                        @change="() => onIndicatorCheck(indicator, 'studentTerm2')"
                      ></el-checkbox>

                      <el-checkbox
                        :value="indicator.term3"
                        class="indicatorLabel"
                        :disabled="true"
                        :id="isPNN1 && !indicator[0].PlnMasLevels.includes('N1S1') ? 'invalid' : ''"
                        @change="() => onIndicatorCheck(indicator, 'term3')"
                      ></el-checkbox>
                      <el-checkbox
                        :value="indicator.studentTerm3"
                        class="studentIndicatorLabel"
                        v-if="ddlStudent"
                        :disabled="indicator.term3 || (isPNN1 && selectedLevel === 'PN')"
                        @change="() => onIndicatorCheck(indicator, 'studentTerm3')"
                      ></el-checkbox>

                      <el-checkbox
                        :value="indicator.term4"
                        class="indicatorLabel"
                        :disabled="true"
                        :id="isPNN1 && !indicator[0].PlnMasLevels.includes('N1S2') ? 'invalid' : ''"
                        @change="() => onIndicatorCheck(indicator, 'term4')"
                      ></el-checkbox>

                      <el-checkbox
                        :value="indicator.studentTerm4"
                        class="studentIndicatorLabel"
                        v-if="ddlStudent"
                        :disabled="indicator.term4 || (isPNN1 && selectedLevel === 'PN')"
                        @change="() => onIndicatorCheck(indicator, 'studentTerm4')"
                      ></el-checkbox>
                    </K2Row>
                  </div>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../../data/datasource'
import { lang, selectedLocale } from '../../locale/index'
import Vue from 'vue'
import VueTour from 'vue-tour'
import K2Row from '../../uiComponents/k2Row/k2Row'
import K2Icon from '../../uiComponents/k2Icon/k2MAIcon'
import uiVariable from '../../config/uiVariable'
import K2ToolTip from '../../uiComponents/k2ToolTip/k2ToolTip'
import Cookies from 'js-cookie'
import PlannerTable from '@/uiComponents/K2PlannerTable/PlannerTable'
import K2Text from '../../uiComponents/k2Text/k2Text'
import './planner.scss'

require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)
Vue.component('blog-post', {
  props: ['post'],
})
export default {
  name: 'PlannerClass',
  components: { K2Text, K2ToolTip, K2Icon, K2Row, PlannerTable },
  props: ['passTourData'],
  data() {
    return {
      uiVariable: uiVariable,
      ddlClassListAll: [],
      ddlClassList: [],
      selectedLevel: '',
      ddlClass: '',
      ddlStudentList: [],
      ddlStudent: '',
      ddlGoalsList: [],
      ddlGoalsListDomain: [],
      studentMode: false,
      goalRefresh: 0,
      isPNN1: false,
      selectedClass: '',
    }
  },

  async created() {
    await this.bindClasses()
  },
  async mounted() {
    await this.fetch()
  },
  methods: {
    lang,
    async fetch() {
      //get goal list for table

      this.ddlGoalsList = await this.groupGoalsList()
      this.ddlGoalsList?.forEach(n => {
        const pos = this.ddlGoalsListDomain.indexOf(n.PlnMasDomain)
        if (pos === -1) {
          this.ddlGoalsListDomain.push(n.PlnMasDomain)
        }
      })
    },
    //--- Set Up for Module-----------------------------------------------------------------------------------------------------------------------------------------------------

    async bindClasses() {
      try {
        const response = await DataSource.shared.getClassList()
        if (response) {
          this.class = response.Table
          this.class.forEach(m => {
            this.ddlClassListAll.push(m)
          })

          this.class.forEach(m => {
            let check = this.ddlClassList.filter(
              m2 =>
                m2.CLS_ClassName.trim() === m.CLS_ClassName.trim() &&
                m2.PK_Semester_ID === m.PK_Semester_ID &&
                m.SC_FK_CourseID === m2.SC_FK_CourseID &&
                m2.PK_Class_ID === m.PK_Class_ID,
            )
            if (check.length < 1) {
              let temp = {
                CLS_ClassName: m.CLS_ClassName.trim(),
                PK_Semester_ID: m.PK_Semester_ID,
                SC_FK_CourseID: m.SC_FK_CourseID,
                SMT_Year: m.SMT_Year,
                PK_Class_ID: m.PK_Class_ID,
                CRS_Level: m.CRS_Level,
                CLS_Batch: m.CLS_Batch,
              }
              if (m.CRS_Level === 'PN' || 'N1') {
                this.ddlClassList.push(temp)
              }
            }
          })
        }
      } catch (e) {
        this.results = e
      }
    },

    async fetchClassGoals() {
      await this.fetch()
      const response = await DataSource.shared.getPlannerAssignedToClass2(this.ddlClass)
      if (response) {
        if (response.code === '2') {
          console.log('getClassCustomGoals no record')
        } else if (response.code === '88') {
          window.location.replace('/')
        } else if (response.code === '99') {
          console.log('getClassCustomGoals error')
        } else {
          this.ddlGoalsList?.forEach(d => {
            d.ArrObj_Items.forEach(m => {
              m.ArrObj_Items.forEach(b => {
                b.term1 = false
                b.studentTerm1 = false
                b.term2 = false
                b.studentTerm2 = false
                b.term3 = false
                b.studentTerm3 = false
                b.term4 = false
                b.studentTerm4 = false
                b?.forEach(a => {
                  let found = response.Table.filter(x => x.PlnClaPlnMasID === a.PlnMasID)
                  if (found) {
                    found.forEach(f => {
                      switch (f.PlnClaType) {
                        case 'PNS1':
                          b.term1 = true
                          b.studentTerm1 = true
                          break
                        case 'PNS2':
                          b.term2 = true
                          b.studentTerm2 = true
                          break
                        case 'N1S1':
                          b.term3 = true
                          b.studentTerm3 = true
                          break
                        case 'N1S2':
                          b.term4 = true
                          b.studentTerm4 = true
                          break
                      }
                    })
                  }
                })
              })
            })
          })
          this.$forceUpdate()
        }
      }
    },
    async fetchStudentGoals() {
      // await this.fetchClassGoals();
      await this.fetch()
      const response = await DataSource.shared.GetPlannerAssignedToStudent(this.ddlStudent)
      if (response) {
        if (response.code === '2' || response?.Table?.length < 1) {
          console.log('getStudentsCustomGoals no record')
        } else if (response.code === '88') {
          window.location.replace('/')
        } else if (response.code === '99') {
          console.log('getClassCustomGoals error')
        } else {
          this.ddlGoalsList.forEach(d => {
            d.ArrObj_Items.forEach(m => {
              m.ArrObj_Items.forEach(b => {
                b?.forEach(a => {
                  let found = response.Table.filter(x => x.PlnStaPlnMasID === a.PlnMasID)
                  if (found) {
                    found.forEach(foundItem => {
                      switch (foundItem.PlnStaType) {
                        case 'PNS1':
                        case this.selectedClass?.CRS_Level + 'T1':
                          b.studentTerm1 = true
                          break
                        case 'PNS2':
                        case this.selectedClass?.CRS_Level + 'T2':
                          b.studentTerm2 = true
                          break
                        case 'N1S1':
                        case this.selectedClass?.CRS_Level + 'T3':
                          b.studentTerm3 = true
                          break
                        case 'N1S2':
                        case this.selectedClass?.CRS_Level + 'T4':
                          b.studentTerm4 = true
                          break
                      }
                    })
                  }
                })
              })
            })
          })
        }
        this.$forceUpdate()
      }
    },

    async getPlannerMaster(LevelType) {
      try {
        let results = []
        let newGoalsList = []

        let IB = 'NON IB'

        if (Cookies.get('schoolSession') === 'SCH201400000553' || Cookies.get('schoolSession') === 'SCH201400000471') {
          if (LevelType === 'N2' || LevelType === 'K1' || LevelType === 'K2') {
            IB = 'IB'
          } else if (selectedLocale() === 'CH') {
            IB = 'IB'
          }
        }
        const response = await DataSource.shared.getPlannerMaster(LevelType, '', '', '', IB)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getPlannerMaster error')
          } else if (response.code === '2') {
            console.log('getPlannerMaster no record')
          } else {
            results = response.Table

            results.forEach(m => {
              const exist = newGoalsList?.find(d => d.PlnMasDomain?.trim() === m.PlnMasDomain?.trim())
              if (!exist) {
                const newGoal = {
                  PlnMasDomain: m.PlnMasDomain,
                  ArrObj_Items: [],
                }

                const goalExist = newGoal.ArrObj_Items.find(d => d.CombineGoals?.trim() === m.PlnMasGoalsNEL?.trim())
                if (goalExist) {
                  goalExist.ArrObj_Items.push(m)
                } else {
                  const newGoalItem = {
                    CombineGoals: m.PlnMasGoalsNEL,
                    ArrObj_Items: [m],
                  }
                  newGoal.ArrObj_Items.push(newGoalItem)
                }
                newGoalsList.push(newGoal)
              } else {
                const goalExist = exist.ArrObj_Items.find(d => d.CombineGoals?.trim() === m.PlnMasGoalsNEL?.trim())
                if (goalExist) {
                  goalExist.ArrObj_Items.push(m)
                } else {
                  const newGoalItem = {
                    CombineGoals: m.PlnMasGoalsNEL,
                    ArrObj_Items: [m],
                  }
                  exist.ArrObj_Items.push(newGoalItem)
                }
              }
            })
          }
        }
        return newGoalsList
      } catch (e) {
        this.results = e
      }
    },
    async getNewPlannerMaster(level) {
      try {
        let levelList = []
        if (Array.isArray(level)) {
          levelList = level
        } else {
          levelList.push(level)
        }

        const response = await DataSource.shared.getPlannerMaster2(JSON.stringify(levelList))
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getPlannerMaster error')
          } else if (response.code === '2') {
            console.log('getPlannerMaster no record')
          } else {
            return response
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async groupGoalsList() {
      let level = this.ddlClassList?.find(d => d.PK_Class_ID === this.ddlClass)
      this.results = await this.getNewPlannerMaster(this.isPNN1 ? ['PNS1', 'N1S1'] : level?.CRS_Level)
      let newGoalsList = []
      if (this.results) {
        let newResult = this.separateGoalByLang()

        newResult.forEach(m => {
          // let split = d?.PlnMasOrder.split(".");
          // d.goalOrder = `${split[0]}.${split[1]}`;
          m.term1 = false
          m.term2 = false
          m.term3 = false
          m.term4 = false
          m.studentTerm1 = false
          m.studentTerm2 = false
          m.studentTerm3 = false
          m.studentTerm4 = false
          let tempCombineGoals
          let assignedList = m?.[0]?.PlnMasLevels?.split(',')
          assignedList?.forEach(f => {
            switch (f) {
              case 'PNS1':
              case this.selectedClass?.CRS_Level + 'T1':
                m.term1 = true
                this.$set(m, 'term1', true)
                break
              case 'PNS2':
              case this.selectedClass?.CRS_Level + 'T2':
                m.term2 = true
                break
              case 'N1S1':
              case this.selectedClass?.CRS_Level + 'T3':
                m.term3 = true
                break
              case 'N1S2':
              case this.selectedClass?.CRS_Level + 'T4':
                m.term4 = true
                break
            }
          })
          let enLabel = m?.find(goal => goal?.PlnMasLang === 'EN')
          let cnLabel = m?.find(goal => goal?.PlnMasLang === 'CH' || goal?.PlnMasLang === 'CN')
          if (m?.[0]?.PlnMasDomain?.trim() === 'The Child as a Communicator' || m?.[0]?.PlnMasDomain?.trim() === '善交流的儿童') {
            m.PlnMasDomain = `The Child as a Communicator 善交流的儿童`
          } else {
            m.PlnMasDomain = `${enLabel?.PlnMasDomain?.trim()} ${cnLabel?.PlnMasDomain?.trim()}`
          }
          // tempCombineGoals = cnLabel===undefined ? `${enLabel?.PlnMasGoals}` : `${enLabel?.PlnMasGoals} ${cnLabel?.PlnMasGoals}`;
          let enGoal = enLabel !== undefined ? enLabel?.PlnMasGoals : ''
          let cnGoal = cnLabel !== undefined ? cnLabel?.PlnMasGoals : ''
          tempCombineGoals = enGoal + ' ' + cnGoal
          m.forEach(d => {
            if (d?.PlnMasOrder !== '') {
              let split = d?.PlnMasOrder.split('.')
              d.goalOrder = `${split[0]}.${split[1]}`
            }
            d.combineIndicator = `${m?.[0]?.PlnMasIndicator}`
          })

          const exist = newGoalsList?.find(d => d.PlnMasDomain?.trim() === m.PlnMasDomain?.trim())

          if (!exist) {
            if (m?.PlnMasDomain) {
              const newGoal = {
                PlnMasDomain: m.PlnMasDomain,
                ArrObj_Items: [],
              }
              const goalExist = newGoal.ArrObj_Items.find(d => d.CombineGoals?.trim() === tempCombineGoals?.trim())
              if (goalExist) {
                goalExist.ArrObj_Items.push(m)
              } else {
                const newGoalItem = {
                  CombineGoals: tempCombineGoals,
                  goalOrder: m?.[0]?.goalOrder,
                  ArrObj_Items: [m],
                }
                newGoal.ArrObj_Items.push(newGoalItem)
              }
              newGoalsList.push(newGoal)
            }
          } else {
            const goalExist = exist.ArrObj_Items.find(d => d.CombineGoals?.trim() === tempCombineGoals?.trim())
            if (goalExist) {
              goalExist.ArrObj_Items.push(m)
            } else {
              const newGoalItem = {
                CombineGoals: tempCombineGoals,
                goalOrder: m?.[0]?.goalOrder,
                ArrObj_Items: [m],
              }
              exist.ArrObj_Items.push(newGoalItem)
            }
          }
        })
      }
      return newGoalsList
    },
    separateGoalByLang() {
      let newResult = []
      if (this.isPNN1) {
        this.results?.forEach(d => {
          if (d?.[0]?.PlnMasDomain === 'The Child as a Communicator' || d?.[0]?.PlnMasDomain === '善交流的儿童') {
            if (d?.[0]?.PlnMasOrder?.includes('2.1.') || d?.[0]?.PlnMasOrder?.includes('2.2.')) {
              newResult?.push([d?.[0]])
              if (d?.length > 1) {
                newResult?.push([d?.[1]])
              }
            } else {
              newResult?.push(d)
            }
          } else {
            newResult?.push(d)
          }
        })
        return newResult
      } else {
        return this.results
      }
    },
    //--- Class and Student Selection-----------------------------------------------------------------------------------------------------------------------------------------------------

    async ClassChange(val) {
      //get semdID
      // await this.bindSemesterDetails();
      await this.getClassStudentList()
      this.checkPNN1(val)
      await this.fetch()
      // await this.fetchClassGoals();
      this.studentMode = false
      this.ddlStudent = ''
    },
    checkPNN1(PK_Class_ID) {
      this.selectedClass = this.ddlClassList?.find(d => d.PK_Class_ID === PK_Class_ID)
      this.isPNN1 = this.selectedClass?.CRS_Level === 'PN' || this.selectedClass?.CRS_Level === 'N1'
    },
    async SelectStudent() {
      this.$vs.loading()
      this.studentMode = true
      await this.fetchStudentGoals()
      this.elementRefresh()
      this.$vs.loading.close()
    },

    async getClassStudentList() {
      try {
        if (this.ddlClass === '') {
          this.$notify.error({
            title: 'Error',
            message: 'Please select Class...',
          })
        } else {
          this.ddlStudentList = []
          let selectedClass = await this.ddlClassList.find(d => d.PK_Class_ID === this.ddlClass)
          this.selectedLevel = selectedClass.CRS_Level
          const response = await DataSource.shared.getStudentsByClass(selectedClass.SC_FK_CourseID, selectedClass.PK_Class_ID, selectedClass.PK_Semester_ID)
          if (response) {
            if (response.code === '2') {
              console.log('getPlannerAssignedStudentSummaryByClassSemester no record')
            } else if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              console.log('getPlannerAssignedStudentSummaryByClassSemester error')
            } else {
              this.ddlStudentList = response.Table
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async saveStudentGoals2() {
      let checkList = []
      this.ddlGoalsList.forEach(d => {
        d.ArrObj_Items.forEach(x => {
          let checked = x.ArrObj_Items.filter(n => Object.values(n).some(val => val === true))
          // let checked = x.ArrObj_Items.filter(n => (n.studentTerm1 === true || n.studentTerm2 === true || n.studentTerm3 === true || n.studentTerm4 === true ||n.term1 === true || n.term2 === true || n.term3 === true || n.term4 === true));
          if (checked) {
            const termMapping = {
              studentTerm1: this.isPNN1 ? 'PNS1' : this.selectedClass?.CRS_Level + 'T1',
              studentTerm2: this.isPNN1 ? 'PNS2' : this.selectedClass?.CRS_Level + 'T2',
              studentTerm3: this.isPNN1 ? 'N1S1' : this.selectedClass?.CRS_Level + 'T3',
              studentTerm4: this.isPNN1 ? 'N1S2' : this.selectedClass?.CRS_Level + 'T4',
            }

            checked.forEach(a => {
              Object.keys(termMapping).forEach(termProp => {
                if (a[termProp]) {
                  a.forEach(m => {
                    checkList.push({
                      PlnStaPlnMasID: m.PlnMasID,
                      PlnStaType: termMapping[termProp],
                    })
                  })
                }
              })
            })
          }
        })
      })
      const response = await DataSource.shared.SavePlannerAssignedToStudent(this.ddlStudent, checkList)
      if (response) {
        switch (response.code) {
          case '1':
            this.$notify({
              title: lang('Success'),
              message: lang('Planner saved.'),
              type: 'success',
            })
            this.fetchStudentGoals()
            break
          case '88':
            this.$vs.loading.close()
            this.$notify.error({
              title: lang('Error'),
              message: lang('Session has expired, please login again.'),
            })
            break
          case '99':
            this.$vs.loading.close()
            this.$notify.error({
              title: lang('Error'),
              message: lang('System Error'),
            })
            break
        }
      }
    },
    async saveClassGoals2() {
      let checkList = []
      this.ddlGoalsList.forEach(d => {
        d.ArrObj_Items.forEach(x => {
          let checked = x.ArrObj_Items.filter(n => n.term1 === true || n.term2 === true || n.term3 === true || n.term4 === true)
          if (checked) {
            checked.forEach(a => {
              let selected
              if (a.term1) {
                selected = 'PNS1'
                a.forEach(m => {
                  checkList.push({
                    PlnClaPlnMasID: m.PlnMasID,
                    PlnClaType: selected,
                  })
                })
              }
              if (a.term2) {
                selected = 'PNS2'
                a.forEach(m => {
                  checkList.push({
                    PlnClaPlnMasID: m.PlnMasID,
                    PlnClaType: selected,
                  })
                })
              }
              if (a.term3) {
                selected = 'N1S1'
                a.forEach(m => {
                  checkList.push({
                    PlnClaPlnMasID: m.PlnMasID,
                    PlnClaType: selected,
                  })
                })
              }
              if (a.term4) {
                selected = 'N1S2'
                a.forEach(m => {
                  checkList.push({
                    PlnClaPlnMasID: m.PlnMasID,
                    PlnClaType: selected,
                  })
                })
              }
            })
          }
        })
      })
      const response = await DataSource.shared.SavePlannerAssignedToClass2(this.ddlClass, checkList)
      if (response) {
        switch (response.code) {
          case '1':
            this.$notify({
              title: lang('Success'),
              message: lang('Planner saved.'),
              type: 'success',
            })
            this.fetchClassGoals()
            break
          case '88':
            this.$vs.loading.close()
            this.$notify.error({
              title: lang('Error'),
              message: lang('Session has expired, please login again.'),
            })
            break
          case '99':
            this.$vs.loading.close()
            this.$notify.error({
              title: lang('Error'),
              message: lang('System Error'),
            })
            break
        }
      }
    },

    async resetStudent() {
      this.ddlStudent = ''
      this.ddlCustomGoalList = []
      this.studentMode = false
      await this.ClassChange()
    },

    elementRefresh() {
      this.goalRefresh++
    },

    onIndicatorCheck(indicator, type) {
      indicator[type] = !indicator[type]
      switch (type) {
        case 'term1':
          indicator.studentTerm1 = !indicator.studentTerm1
          break
        case 'term2':
          indicator.studentTerm2 = !indicator.studentTerm2
          break
        case 'term3':
          indicator.studentTerm3 = !indicator.studentTerm3
          break
        case 'term4':
          indicator.studentTerm4 = !indicator.studentTerm4
          break
      }
      this.$forceUpdate()
    },

    handleSelectGoals(selected) {
      let selectedDomain = this.ddlGoalsList.find(d => d.PlnMasDomain === selected)
      return selectedDomain.ArrObj_Items
    },
  },
}
</script>

<style scoped>
.sc-table {
  margin-top: 0px;
}

.sc-table .el-table__header-wrapper {
  display: none !important;
}
</style>
